import { connect } from 'react-redux';
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

function WithRoles(Component) {
  class Roles extends PureComponent {
    hasUserPermission = roles => {
      const { user } = this.props;

      if (Array.isArray(roles)) {
        return roles.includes(user.UserRole);
      }

      return roles === user.UserRole;
    };

    render() {
      return (
        <Component hasUserPermission={this.hasUserPermission} {...this.props} />
      );
    }
  }

  Roles.propTypes = {
    user: PropTypes.object
  };

  const mapStateToProps = state => ({
    user: state.auth.user
  });

  return connect(
    mapStateToProps,
    null
  )(Roles);
}

export default WithRoles;
